<template>
  <main class="dashboard-page afro-bg">
    <section class="dashboard-shell paper-panel">
      <header class="dash-head">
        <div>
          <p class="eyebrow">Panel Afrogato</p>
          <h1>Bienvenido</h1>
          <span>{{ isAdmin ? 'Gestion del menu, recetario y usuarios internos.' : 'Consulta tu wallet, puntos y menu digital.' }}</span>
        </div>
        <img src="/assets/afrogato/logo-afrogato.png" alt="Afrogato" />
      </header>

      <div class="dash-grid">
        <router-link class="dash-card wallet" to="/wallet">
          <b>Mi wallet</b>
          <span>Consulta puntos, QR de cliente, tickets y canjes.</span>
        </router-link>
        <router-link v-if="isAdmin" class="dash-card" to="/recetas">
          <b>Recetario</b>
          <span>Consulta recetas por categoria y producto.</span>
        </router-link>
        <router-link v-if="$canView('administrador','superadministrador')" class="dash-card" to="/catalogo">
          <b>Catalogo</b>
          <span>Edita categorias, precios, activos, orden y recetas.</span>
        </router-link>
        <router-link class="dash-card" to="/menu" target="_blank">
          <b>Menu digital</b>
          <span>Abre la vista vertical para monitor o celular.</span>
        </router-link>
        <router-link v-if="$canView('administrador','superadministrador')" class="dash-card" to="/usuarios">
          <b>Usuarios</b>
          <span>Administra accesos y permisos.</span>
        </router-link>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: 'HomeView',
  computed: {
    isAdmin() {
      return ['administrador', 'superadministrador'].includes(this.$store.state.role)
    }
  }
}
</script>

<style scoped>
.dashboard-page { min-height: 100vh; width: 100%; padding: 28px; }
.dashboard-shell { width: min(1100px, 100%); margin: 0 auto; padding: 28px; }
.dash-head { display: flex; justify-content: space-between; align-items: center; gap: 20px; text-align: left; border-bottom: 1px dashed var(--afro-line); padding-bottom: 18px; }
.dash-head img { width: 220px; }
.eyebrow { margin: 0 0 8px; color: var(--afro-gold); font-weight: 900; text-transform: uppercase; letter-spacing: .16em; }
h1 { margin: 0; font-family: var(--afro-text-serif); font-size: clamp(42px, 6vw, 72px); }
.dash-head span { color: var(--afro-olive); font-weight: 800; }
.dash-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 18px; margin-top: 24px; }
.dash-card { min-height: 170px; border: 1px solid rgba(38,51,31,.2); border-radius: 22px; background: rgba(255,248,230,.56); padding: 22px; text-align: left; text-decoration: none; color: var(--afro-ink); display: flex; flex-direction: column; justify-content: flex-end; transition: transform .18s ease, background .18s ease; }
.dash-card:hover { transform: translateY(-3px); background: var(--afro-olive); color: var(--afro-paper-light); }
.dash-card b { font-family: var(--afro-text-serif); font-size: 34px; }
.dash-card span { font-weight: 700; margin-top: 8px; }
@media (max-width: 760px) { .dashboard-page { padding: 0; } .dashboard-shell { border-radius: 0; padding: 18px; } .dash-head { flex-direction: column; align-items: flex-start; } .dash-head img { width: 190px; } .dash-grid { grid-template-columns: 1fr; } }
</style>
